import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Shield, Settings, FileText, TrendingUp } from 'lucide-react';
export function WhyChooseUs() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const pillars = [{
    icon: Settings,
    title: 'Cero Preocupaciones',
    description: 'Nos encargamos del 100% de la gestión: desde el mantenimiento técnico hasta la relación con el inquilino.'
  }, {
    icon: Shield,
    title: 'Filtro Riguroso',
    description: 'Protegemos su inversión con una selección exhaustiva de inquilinos y contratos legales de alta seguridad.'
  }, {
    icon: FileText,
    title: 'Transparencia Total',
    description: 'Reportes claros y comunicación directa. Usted siempre tiene el control de sus ingresos y gastos.'
  }, {
    icon: TrendingUp,
    title: 'Visión Local',
    description: 'Expertos en el mercado de Playa del Carmen. Sabemos cómo posicionar su propiedad para obtener el mejor ROI.'
  }];
  return <section id="nosotros" className="py-24 bg-pearl relative overflow-hidden" data-id="element-243">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-244">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-245" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-246" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16 md:mb-24" data-id="element-248">
          <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-249">
            Nuestra Promesa
          </span>
          <h2 className="text-4xl md:text-5xl font-playfair text-charcoal mb-6" data-id="element-250">
            ¿Por Qué Elegir Grand Town?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-251" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6" data-id="element-252">
          {pillars.map((pillar, index) => <motion.div key={index} variants={itemVariants} className="group bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-100 hover:border-gold/30 relative overflow-hidden" data-id="element-253">
              {/* Hover accent line */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gold scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" data-id="element-254" />

              <div className="w-14 h-14 rounded-xl bg-pearl flex items-center justify-center mb-6 group-hover:bg-gold/10 transition-colors duration-300" data-id="element-255">
                <pillar.icon className="text-gold" size={28} strokeWidth={1.5} data-id="element-256" />
              </div>

              <h3 className="text-xl font-playfair font-semibold text-charcoal mb-4 group-hover:text-gold transition-colors duration-300" data-id="element-257">
                {pillar.title}
              </h3>

              <p className="text-charcoal/70 leading-relaxed text-sm md:text-base" data-id="element-258">
                {pillar.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}